// extracted by css-extract-rspack-plugin
export default {"root":"fm5JHq","title":"ZEQgMM","subscriber-count":"ler48d","subscriberCount":"ler48d"};